import { useEffect, useRef } from "react";

/**
 * Calls `onRestored` when the page is shown from the back-forward cache, which keeps the React
 * state it was left with (e.g. a stale "redirect in flight" flag).
 */
export function usePageRestored(onRestored: () => void) {
  const callback = useRef(onRestored);
  callback.current = onRestored;

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) callback.current();
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
}
